import React from "react"

// Hook to return and render remaining time until future timestamp

/* Params
 *
 * @timestamp - [number] the future time for comparison
 * @format - [string] the format of the returned string 
 *  - accepts "h", "m", "s" in single or double (eg "h - mm - ss")
 *  - default: "hh:mm:ss"
 * 
 * returns [string] based on format
 */

type Props = {
  timestamp?: number;
  format?: string;
  onTimeUp?: () => void;
}

const useRemainingTime = ({
  timestamp,
  format = "hh:mm:ss",
  onTimeUp = () => null
}: Props ) => {
  const [_timestamp, setTimestamp] = React.useState<number | undefined>(timestamp);
  const [remainingTime, setRemainingTime] = React.useState(0);

  const formatTime = () => {
    const hours = Math.floor(remainingTime / (60 * 60 * 1000));
    const minutes = Math.floor(remainingTime / (60 * 1000));
    const seconds = Math.floor(remainingTime / 1000) % 60;

    let formatted = format;
    formatted = formatted.replace('hh', hours.toString().padStart(2, '0'))
    formatted = formatted.replace('h', hours.toString())
    formatted = formatted.replace('mm', minutes.toString().padStart(2, '0'))
    formatted = formatted.replace('m', minutes.toString())
    formatted = formatted.replace('ss', seconds.toString().padStart(2, '0'))
    formatted = formatted.replace('s', seconds.toString())
    
    return formatted;
  }

  React.useEffect(() => {
    if (!_timestamp) return;

    const interval = setInterval(() => {
      const currentTime = Date.now();
      const timeDifference = _timestamp - currentTime;

      if (timeDifference <= 0) {
        clearInterval(interval);
        setRemainingTime(0);
        
        onTimeUp();
      } else {
        setRemainingTime(timeDifference);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  })

  return ({
    remainingTime,
    setTimestamp,
    formattedTime: formatTime()
  })
}

export { useRemainingTime as default }